import getApi from '../../api'
import { PrescriptionUpdate, Prescription } from '../../model/Prescription'

export const updatePrescription = (
  prescriptionId: string,
  prescriptionUpdate: Partial<PrescriptionUpdate>,
) => getApi().put<Prescription>(`/prescriptions/${prescriptionId}`, prescriptionUpdate)
